var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopSocialTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.855 6.401c-.34.22-1.12.541-1.504.541a2.4 2.4 0 0 0-1.743-.755c-1.331 0-2.41 1.095-2.41 2.444q0 .281.06.545c-1.806-.048-3.782-.965-4.97-2.536-.732 1.283-.1 2.71.73 3.23-.284.021-.806-.034-1.052-.277-.017.851.387 1.98 1.86 2.388-.284.155-.786.11-1.004.078.076.719 1.07 1.658 2.155 1.658-.387.454-1.843 1.277-3.477 1.015a7.17 7.17 0 0 0 3.772 1.08c3.89 0 6.91-3.195 6.748-7.137v-.044l-.001-.036c.354-.245.829-.68 1.169-1.251-.197.11-.788.33-1.338.385.353-.193.876-.825 1.005-1.328"
}))));
export default SvgTiktokDesktopSocialTwitter;